/**
 * Adresser till admin-api och vilken kund (tenant) frontenden pratar för.
 */

export const zigbeeConfig = {
    // Backend API Endpoints (admin-api service)
    get apiOrigin() {
        const host = typeof window !== 'undefined' ? window.location.hostname : '';
        const isLocalHost = host === 'localhost' || host === '127.0.0.1';
        return isLocalHost
            ? 'http://localhost:4000'
            : 'https://deviot.devinvest.se';
    },
    get apiBaseUrl() {
        return `${this.apiOrigin}/api`;
    },

    /** Tenant slug derived from subdomain. Sent as X-Tenant-Id on every request. */
    get tenantId() {
        const host = typeof window !== 'undefined' ? window.location.hostname : '';
        if (!host || host === 'localhost' || host === '127.0.0.1') return 'saltvik';
        return host.split('.')[0]; // 'saltvik' | 'kund2' | ...
    },
};

export default zigbeeConfig;
